import { useLocation, useNavigate } from "react-router-dom";
import EditAssessmentQuestion from "./EditAssessmentQuestion";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import userProfileSelectors from "../../../../../redux/UserProfile/selectors"
import permissions, { isAuthorized } from "client/utils/Permissions";

const EditAssessmentQuestionContainer = () => {
  const navigate = useNavigate();

  const { state } = useLocation()
  
  const { userDetails } : any = useSelector((state: any) => ({ 
    userDetails: userProfileSelectors.getUserDetails(state),
  }))
  
  useEffect(() => {
    if(userDetails?.permissions?.length && !(isAuthorized(permissions.CreateAssessment) || isAuthorized(permissions.ViewAssessment))){
      navigate('/assetinventory')
    }
  }, [userDetails?.permissions])
  
  const breadcrumlist = [
    {
      text: "Home",
      key: "f1",
      href: "/assetinventory/questions",
      onClick: (e: any) => {
        e.preventDefault();
        handleClickBack()
      },
    },
    { text: "Edit Module", key: "f2" },
  ];
  
    const handleClickBack = () =>{
        navigate('/assetinventory/questions')
    }

    return <EditAssessmentQuestion breadcrumlist={breadcrumlist} handleClickBack={handleClickBack} assessmentById={state?.rowData}/>
}

export default EditAssessmentQuestionContainer;